
import * as noneRuntime$WomlfPfFTX from '/opt/buildhome/repo/node_modules/.pnpm/@nuxt+image@1.3.0/node_modules/@nuxt/image/dist/runtime/providers/none'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "none",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "avif",
    "jpeg",
    "png",
    "jpg",
    "svg",
    "webp"
  ],
  "quality": 80
}

imageOptions.providers = {
  ['none']: { provider: noneRuntime$WomlfPfFTX, defaults: {} }
}
        